import { Link } from 'react-router-dom';
import { announcements } from '@/mocks/data';

export default function AnnouncementBar() {
  const urgent = announcements.filter((a) => a.isUrgent);
  const normal = announcements.filter((a) => !a.isUrgent);

  return (
    <section className="py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-8 h-8 flex items-center justify-center">
            <i className="ri-megaphone-line text-xl text-primary-500"></i>
          </div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            官方公告
          </h2>
          <Link
            to="/category/announcements"
            className="ml-auto text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {urgent.map((ann) => (
            <div
              key={ann.id}
              className="bg-primary-50 border border-primary-200 rounded-lg p-5 relative overflow-hidden"
            >
              <span className="absolute top-0 right-0 bg-primary-500 text-white text-xs px-3 py-1 rounded-bl-lg font-medium">
                重要
              </span>
              <h4 className="font-heading font-semibold text-foreground-950 mb-2 pr-12 text-sm">
                {ann.title}
              </h4>
              <p className="text-foreground-600 text-xs leading-relaxed mb-3">
                {ann.content}
              </p>
              <span className="text-foreground-400 text-xs">{ann.publishDate}</span>
            </div>
          ))}
          {normal.map((ann) => (
            <div
              key={ann.id}
              className="bg-background-100 border border-background-200/70 rounded-lg p-5"
            >
              <h4 className="font-heading font-semibold text-foreground-950 mb-2 text-sm">
                {ann.title}
              </h4>
              <p className="text-foreground-600 text-xs leading-relaxed mb-3">
                {ann.content}
              </p>
              <span className="text-foreground-400 text-xs">{ann.publishDate}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}